function refreshCart() {
      $.getJSON('/cart.json').then(cart => {
          fetch('cart?view=item').then(response => response.text())
          .then(text => {
              const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
              const cartFormInnerHTML = sectionInnerHTML.getElementById('CartDrawer').innerHTML;
              const totalPrice=sectionInnerHTML.querySelector('#CartDrawer .totals__subtotal-value').innerHTML;
              $('#CartDrawer').html(cartFormInnerHTML)
              $('cart-drawer').removeClass('is-empty')
              $('cart-drawer-items').removeClass('is-empty')
            if($('#cart-icon-bubble .cart-count-bubble').length===0){
              const cartNumber=document.createElement('div')
              cartNumber.className='cart-count-bubble'
              cartNumber.innerHTML=`
              <span aria-hidden="true">${cart.item_count}</span>
              <span class="visually-hidden">${cart.item_count} items</span>
              `
              $('#cart-icon-bubble').append(cartNumber)
            }else{
               $('.cart-count-bubble span[aria-hidden="true"]').each((_,count)=>$(count).text(cart.item_count))
            }
             $('#cart-icon-bubble')[0].click()
              $('#CartDrawer-Overlay').on('click',()=>{
                $('cart-drawer').removeClass('active')
                $('body').removeClass('overflow-hidden')
              })
          })
      });
  }